import { Controller } from "@hotwired/stimulus"
import { useDebounce, useHotkeys } from "stimulus-use"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["query", "form"]
  static outlets = ["sidebar"]
  static debounces = ["process"]
  static values = { sidebarPath: String }

  connect() {
    useDebounce(this, { wait: 200 })
    useHotkeys(this, {
      "/": [this.focusSearch],
    })
  }

  process() {
    this.formTarget.requestSubmit()
  }

  toggleSidebar() {
    if (this.hasSidebarOutlet) {
      this.sidebarOutlet.toggle()
    } else if (this.hasSidebarPathValue) {
      document.querySelector("#sidebar").src = this.sidebarPathValue
    }
  }

  focusSearch(event) {
    event.preventDefault()
    this.queryTarget.focus()
    this.queryTarget.select()
  }
}
